<template>
  <bita-modal
    id="slide-form"
    :title="title"
    :modal-lg="true"
    :is-loading="isLoading"
    @close="reset"
  >
    <div slot="body">
      <bita-form ref="form">
        <div slot="body">
          <div class="row">
            <bita-input
              type="text"
              name="title"
              label="عنوان"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.title"
            />
            <bita-uploader
              name="icon"
              label="تصویر"
              ref="uploader"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.image"
              :icon-url="formData.image_url"
            />
            <bita-uploader
              name="icon"
              label="تصویر گوشی"
              ref="uploader2"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.mobile_image"
              :icon-url="formData.mobile_image_url"
            />
            <bita-input
              type="number"
              name="order"
              min="0"
              label="ترتیب"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.order"
            />
            <bita-input
              type="text"
              name="link"
              label="آدرس"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.link"
            />
            <!-- <bita-input
              type="text"
              name="link"
              label="آدرس (اپلیکیشن)"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.mobile_link"
            /> -->
            <bita-select
              name="type"
              ref="typeSelect"
              label="نوع لینک موبایل"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { key: 'product', name: 'دسته بندی' },
                { key: 'product-detail', name: 'محصول' },
                { key: 'about', name: 'صفحات' },
                { key: 'blog', name: 'فیش مگ' },
                { key: 'contact', name: 'تماس باما' },
                { key: 'promotion-products', name: 'حراج' },
                { key: 'link', name: 'دلخواه' },
              ]"
              data-text-field="name"
              data-value-field="key"
              v-model="formData.link_type"
            />
            <bita-input
              type="text"
              name="mobile_link"
              label="لینک دلخواه"
              :validation-container-class="colWidth"
              input-class="form-control"
              v-model="formData.link_meta"
              v-show="isLinkCustom"
            />
            <bita-select
              name="link-products"
              ref="link-products"
              v-if="isLinkProduct && linkProducts.length"
              label="لینک به محصول"
              subtitle="لطفا محصول مورد نظر را جستجو نمایید."
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[{ id: 0, name: 'انتخاب کنید' }, ...linkProducts]"
              data-text-field="name"
              data-value-field="id"
              :get-data="getProducts"
              v-model="formData.link_meta"
            />
            <bita-select
              name="link-category"
              ref="link-category"
              v-else-if="isLinkCategory && linkCategories.length"
              label="لینک به دسته بندی"
              subtitle="لطفا دسته بندی مورد نظر را جستجو نمایید."
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[{ id: 0, name: 'انتخاب کنید' }, ...linkCategories]"
              data-text-field="name"
              data-value-field="id"
              :get-data="getCategories"
              v-model="formData.link_meta"
            />
            <bita-select
              name="link-static-page"
              ref="link-static-page"
              v-else-if="isLinkStaticPage && linkStaticPages.length"
              label="لینک به صفحات"
              subtitle="لطفا صفحات مورد نظر را جستجو نمایید."
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { id: 0, title: 'انتخاب کنید' },
                ...linkStaticPages,
              ]"
              data-text-field="title"
              data-value-field="id"
              :get-data="getStaticPages"
              v-model="formData.link_meta"
            />
            <bita-select
              name="link-promotion-products"
              ref="link-promotion-products"
              v-else-if="isLinkPromotion && linkPromotionProducts.length"
              label="لینک به حراج ها"
              subtitle="لطفا صفحات مورد نظر را جستجو نمایید."
              rules=""
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { id: 0, title: 'انتخاب کنید' },
                ...linkPromotionProducts,
              ]"
              data-text-field="title"
              data-value-field="id"
              :get-data="getPromotionProducts"
              v-model="formData.link_meta"
            />
            <bita-select
              name="type"
              ref="typeSelect"
              label="نوع"
              rules="required"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { id: 1, name: 'اسلایدر' },
                { id: 2, name: 'بنر وسط' },
                { id: 3, name: 'بنر ساید بار' },
                { id: 4, name: 'بنر سرصفحه' },
              ]"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.type"
            />
            <bita-select
              name="size"
              ref="sizeSelect"
              label="اندازه"
              :rules="isProductPic ? 'required' : ''"
              v-show="isProductPic"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { id: 1, name: 'کوچک' },
                { id: 2, name: 'متوسط' },
                { id: 3, name: 'بزرگ' },
              ]"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.size"
            />
            <bita-select
              name="size"
              ref="sizeSelect"
              label="اندازه"
              :rules="isSlider ? 'required' : ''"
              v-show="isSlider"
              :validation-container-class="colWidth"
              input-class="form-control"
              :data-source="[
                { id: 1, name: 'فقط تصویر' },
                { id: 2, name: 'با باکس متن' },
                { id: 3, name: 'متن وسط' },
              ]"
              data-text-field="name"
              data-value-field="id"
              v-model="formData.size"
            />

            <div class="row" v-if="formData.id">
              <img :src="formData.image_url" alt="..." class="img-thumbnail" />
            </div>
          </div>
        </div>
      </bita-form>
    </div>
    <div slot="footer">
      <bita-bootbutton
        v-if="!formData.id"
        type="primary"
        title="ذخیره"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="save"
      />
      <bita-bootbutton
        v-else
        title="بروزرسانی"
        type="primary"
        icon="fas fa-save"
        btn-width="150px"
        @click.native="update"
      />
    </div>
  </bita-modal>
</template>
<script>
import {
  productApi,
  categoryApi,
  staticpageApi,
  promotionApi,
} from "@/api/apiManagement.js";

export default {
  props: {
    title: String,
    isLoading: Boolean,
    slide: Object,
  },
  data() {
    return {
      colWidth: "col-lg-4",
      formData: {},
      linkProducts: [],
      linkCategories: [],
      linkStaticPages: [],
      linkPromotionProducts: [],
    };
  },
  created() {
    productApi.getProducts().then((res) => {
      this.linkProducts = res.data;
    });
    categoryApi.getCategories().then(({ data: { entity } }) => {
      this.linkCategories = entity;
    });
    staticpageApi.getStaticPages().then(({ data: { entity } }) => {
      this.linkStaticPages = entity;
    });
    promotionApi.getPromotions().then(({ data: { entity } }) => {
      this.linkPromotionProducts = entity;
    });
  },
  computed: {
    isProductPic() {
      return this.formData.type == 2;
    },
    isSlider() {
      return this.formData.type == 1;
    },
    isLinkCategory() {
      return this.formData.link_type == "product";
    },
    isLinkCustom() {
      return this.formData.link_type == "link";
    },
    isLinkProduct() {
      return this.formData.link_type == "product-detail";
    },
    isLinkStaticPage() {
      return this.formData.link_type == "about";
    },
    isLinkPromotion() {
      return this.formData.link_type == "promotion-products";
    },
  },
  methods: {
    getProducts(e) {
      if (!e.filter) return;
      productApi.getProducts({ search: e.filter.value }).then((res) => {
        this.linkProducts = _.unionBy(res.data, this.linkProducts, "id");
      });
    },
    getCategories(e) {
      if (!e.filter) return;
      productApi
        .getCategories({ search: e.filter.value })
        .then(({ data: { entity } }) => {
          this.linkCategories = _.unionBy(entity, this.linkCategories, "id");
        });
    },
    getStaticPages(e) {
      if (!e.filter) return;
      productApi
        .getStaticPages({ search: e.filter.value })
        .then(({ data: { entity } }) => {
          this.linkStaticPages = _.unionBy(entity, this.linkStaticPages, "id");
        });
    },
    getPromotionProducts(e) {
      if (!e.filter) return;
      promotionApi
        .getPromotions({ search: e.filter.value })
        .then(({ data: { entity } }) => {
          this.linkPromotionProducts = _.unionBy(
            entity,
            this.linkPromotionProducts,
            "id"
          );
        });
    },
    setForm(data, type, size) {
      this.formData = data;
      setTimeout(() => {
        this.formData.type = type;
      }, 200);
      setTimeout(() => {
        this.formData.size = size;
      }, 200);
    },
    save() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-create", this.formData);
        }
      });
    },
    update() {
      this.$refs.form.validate().then((result) => {
        if (result) {
          this.$emit("on-update", this.formData);
        }
      });
    },
    reset() {
      this.formData = {};
      this.$refs.uploader.reset();
      this.$refs.uploader2.reset();
      this.$refs.typeSelect.emptyKendo();
      if (this.$refs.sizeSelect) this.$refs.sizeSelect.emptyKendo();
      this.$refs.form.reset();
    },
    setErrors(_errors) {
      this.$refs.form.setErrors(_errors);
    },
  },
};
</script>
